import React from "react";
import style from "./css/AboutUs.module.css";
import banner from './assests/banner.jpg';
function AboutUs() {
  const about = [
    {
      id: 1,
      name: "Sky Computer Education, Darbhanga is one of the best computer training center. Running successfully for 10+ years, we offer basic as well as advance level computer training. We are authorized Partner of Tally Education Private Limited.",
    },
    {
      id: 2,
      name: "Sky Computer Educaton provides a wide variety of short term as well as software diploma courses, designed by our expert academicians after careful market study and research. All the courses are taught experienced, dedicated and certified faculties. Our trainers constantly update their technical skills to maintain their expertise.",
    },
  ];
  const facilities = [
    {
      id: 1,
      data: "Well qualified and dedicated team of faculties",
    },
    {
      id: 2,
      data: "Minimum fee",
    },
    {
      id: 3,
      data: "Government recognized certificate",
    },
    {
      id: 4,
      data: "Extra theory and lab class for slow learners",
    },
    {
      id: 5,
      data: "Placement assistance",
    },
    {
      id: 6,
      data: "Classes are conducted in English as well as in Hindi",
    },
  ];
  const details = [
    {
      id: 1,
      name: "Sky Computer Education, Darbhanga is one of the Best Computer Training Institute in Drbhanga. We are ISO 9000 Certified institute which has successfully trained 15,000+ Students in the span of 10+ Years.",
    },
    {
      id: 2,
      name: "Our courses are structured in such a way that you will get detailed explanation of each of the topics. After successfully completing of your course certificate is issued by us which is valid for Central government, state government and Private Jobs",
    },
  ];
  return (
    <>
      <div className={`${style.marquee_container} bg-primary text-light p-2`}>
        <div className={style.marquee_text}>
          <span>
            Welcome to Sky Computer Education, East of Naka No.- 5, Near
            Panchmukhi Hanuman Mandir, Mishratola, Darbhanga
          </span>
        </div>
      </div>
      <div className="container-fluid text-light" style={{background:'#1f1f1f'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className={`col-lg-6 ${style.heading_container}`}>
              <h3 className={style.h3}>Welcome to Sky Computer Education</h3>
              {about.map((e) => (
                <p className={style.p} key={e.id}>
                  {e.name}
                </p>
              ))}
            </div>
            <div className="col-lg-6">
              <img src={banner} alt="" className={style.img} />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <ul>
                {facilities.map((e) => (
                  <li className={style.list} key={e.id}>
                    {e.data}
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-6">
              <ul>
                {details.map((e) => (
                  <li className={style.list} key={e.id}>
                    {e.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
